import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import EMIracker2AllocationUpdateModalUI from './EMIracker2AllocationUpdateModalUI.js'

class EMIracker2AllocationUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      allocation: '',
      allocationError: null,
    }
  }

  render() {

    let allocateList = [
      { key: 'EWS', value: 'EWS' },
      { key: 'Default Expected', value: 'NPA' },
      { key: 'NACH Expected', value: 'Expected NACH' },
      { key: 'Inflow Expected', value: 'Expected Inflow' },
      { key: 'Empty', value: 'Empty' },
    ]
    return (
      <EMIracker2AllocationUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        allocation={this.state.allocation}
        onAllocationChange={(event) => { this.setState({ allocation: event.target.value }) }}
        allocationError={this.state.allocationError}
        setAllcationError={(error) => { this.setState({ allocationError: error }) }}
        //
        allocateList={allocateList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (this.props.updateMode && !prevProps.updateMode) {
      this.setState({
        allocation: this.props.currentAllocation || '',
        allocationError: null,
        successMsg: null,
        errorList: null,
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.selectedLoanId}/repayments/updateAllocation`,
      this.onSubmitCallback, {
      allocation: this.state.allocation === 'Empty' ? '' : this.state.allocation,
    }
    )
  }
  
  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      const savedAllocation = this.state.allocation === 'Empty' ? '' : this.state.allocation
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onAllocationUpdateSuccess(this.props.selectedLoanId, savedAllocation)
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(EMIracker2AllocationUpdateModalSF)
